import { createAction } from "@reduxjs/toolkit";

export const getRelationsSuccess = createAction('relations/getRelationsSuccess')
// export const getSymptomsError = createAction('symptoms/getError')